import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
import {
  FeatureHeader,
  FeatureSection,
} from "../../components/FeatureStyle/FeatureStyle";
import {
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Card,
  Image,
  Text,
  Box,
  Stack,
  Button,
  Grid,
  // GridItem,
  // AspectRatio,
} from "@chakra-ui/react";
import { Search2Icon } from "@chakra-ui/icons";
import PageLoading from "../../components/Loading/PageLoading";

dayjs.extend(tz);
dayjs.extend(advanced);

export default function BlogListWidget({
  charLength,
  data,
  dateFormat,
  displayDate,
  handlePageLeft,
  handlePageRight,
  hideSortByDate,
  limit,
  maxHeight,
  page,
  query,
  route,
  setPage,
  setQuery,
  setSort,
  showImage,
  showSort,
  showSearch,
  sortOrder,
  totalEntries,
  truncate,
}: Record<string, any>): JSX.Element {
  const paginationText = "Page";
  const handler = (e: any) => {
    if (e.key === "Enter") {
      setQuery(query);
    }
  };

  const onChange = (e: any) => {
    setQuery(e.target.value);
  };

  const selectChange = (e: any) => {
    setSort(e.target.value);
  };

  return !data.entries ? (
    <div style={{ height: "50vh" }}>
      <PageLoading />
    </div>
  ) : (
    <Box
      maxW="6xl"
      minH="45vh"
      margin="auto"
    >
      {/* Top bar Search section */}
      <Stack
        pt="1rem"
        pb="1rem"
        direction={["column", "row"]}
        spacing="24px"
        align="center"
        justify="center"
      >
        {showSearch && (
          <Box>
            <Text align="center">Search</Text>
            <InputGroup
              bgColor="white"
              borderRadius="10px"
            >
              <Input
                id="textField"
                type="text"
                name="textField"
                placeholder="Enter Search Here"
                onChange={onChange}
                onKeyDown={(e) => handler(e)}
                value={query}
                aria-label="Enter Search"
              />
              <InputRightElement>
                <IconButton
                  aria-label="submit"
                  type="submit"
                  icon={<Search2Icon />}
                  onClick={() => {
                    setQuery(query);
                  }}
                ></IconButton>
              </InputRightElement>
            </InputGroup>
          </Box>
        )}
        {showSort && (
          <Box>
            <Text align="center">Select Sorting Order</Text>
            <Select
              bgColor="white"
              name="sort"
              id="sort"
              onChange={selectChange}
              defaultValue={sortOrder}
              aria-label="Sorting Order"
            >
              <option
                hidden={hideSortByDate}
                value="dateAsc"
              >
                Date (Ascending Order)
              </option>
              <option
                hidden={hideSortByDate}
                value="dateDesc"
              >
                Date (Descending Order)
              </option>
              <option value="nameAZ">Name (A to Z)</option>
              <option value="nameZA">Name (Z to A)</option>
            </Select>
          </Box>
        )}
      </Stack>
      {totalEntries === 0 ? (
        <div
          style={{
            padding: "1rem",
            fontSize: "1.25rem",
            lineHeight: "1.75rem",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          No results found. Please try another search term.
        </div>
      ) : (
        //Blog Items
        <div style={{ margin: "auto" }}>
          {data.entries.map((entry: any) => (
            <Card
              key={entry?._id.$id}
              overflow="hidden"
              variant="outline"
              padding="1rem"
              margin="1rem"
              bgColor="white"
            >
              <Grid
                gridAutoFlow="column"
                gridAutoColumns="1fr"
                gap={4}
              >
                <Stack>
                  <Link
                    to={{
                      pathname: `/${route}/${entry?._id?.$id}`,
                    }}
                    state={{ title: entry?.title }}
                    style={{ width: "100%" }}
                  >
                    {displayDate && (
                      <strong style={{ fontSize: "1rem" }}>
                        {dateFormat
                          ? dayjs
                              .unix(entry.date.sec)
                              .format(`${dateFormat}`)
                              .toString()
                          : dayjs
                              .unix(entry.date.sec)
                              .format("ddd, MMM DD, YYYY, hh:mm A z")
                              .toString()}
                      </strong>
                    )}
                    <FeatureHeader
                      style={{
                        paddingTop: "0.5rem",
                        paddingBottom: "0.75",
                      }}
                    >
                      {entry?.title}
                    </FeatureHeader>
                  </Link>
                  {truncate ? (
                    <Box>
                      <FeatureSection
                        dangerouslySetInnerHTML={{
                          __html:
                            entry?.content.length > 400
                              ? entry?.content.slice(
                                  0,
                                  charLength ? charLength : 400
                                ) + "<span>...</span>"
                              : entry?.content,
                        }}
                        style={{ paddingBottom: "0.75" }}
                      ></FeatureSection>
                      <Link
                        to={{
                          pathname: `/${route}/${entry?._id?.$id}`,
                        }}
                        state={{ title: entry?.title }}
                      >
                        <Button
                          bgColor="black"
                          color="white"
                          marginY="1rem"
                        >
                          Read More
                        </Button>
                      </Link>
                    </Box>
                  ) : (
                    <Box>
                      <FeatureSection
                        style={{ marginTop: "1rem" }}
                        dangerouslySetInnerHTML={{
                          __html: entry?.content,
                        }}
                      />
                    </Box>
                  )}
                </Stack>

                {entry?.images[0]?.large && showImage !== "none" ? (
                  <Box alignSelf="center">
                    <Link
                      to={{
                        pathname: `/${route}/${entry?._id?.$id}`,
                      }}
                    >
                      <Image
                        alt={`Image for ` + entry?.title}
                        src={entry?.images[0]?.large}
                        loading="lazy"
                        objectFit={"contain"}
                        fallbackSrc="https://ocv-web-icons.s3.us-east-2.amazonaws.com/default_image.jpeg"
                        w="100%"
                        maxHeight={maxHeight ? maxHeight : "20rem"}
                      />
                    </Link>
                  </Box>
                ) : null}
              </Grid>
            </Card>
          ))}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "1rem",
            }}
          >
            <Pagination
              totalEntries={totalEntries}
              limit={limit}
              pageRight={handlePageRight}
              pageLeft={handlePageLeft}
              page={page}
              setPage={setPage}
              paginationText={paginationText}
            />
          </div>
        </div>
      )}
    </Box>
  );
}
